const typography = {
  web: {
    h1: {
      fontSize: "40px",
      lineHeight: "120%",
      fontFamily: "MadeTommySoft",
      fontWeight: "800",
      letterSpacing: "0.04em",
      margin: "0",
    },
    h2: {
      fontSize: "32px",
      lineHeight: "120%",
      fontFamily: "MadeTommySoft",
      fontWeight: "700",
      letterSpacing: "0.03em",
      margin: "0",
    },
    h3: {
      fontSize: "28px",
      lineHeight: "120%",
      fontFamily: "MadeTommySoft",
      fontWeight: "500",
      letterSpacing: "0.02em",
      margin: "0",
    },
    h4: {
      fontSize: "20px",
      lineHeight: "120%",
      fontFamily: "MadeTommySoft",
      fontWeight: "500",
      letterSpacing: "0.04em",
      margin: "0",
    },
    h5: {
      fontSize: "18px",
      lineHeight: "150%",
      fontFamily: "MadeTommySoft",
      fontWeight: "500",
      letterSpacing: "0.04em",
      margin: "0",
    },
    h6: {
      fontSize: "16px",
      lineHeight: "150%",
      fontFamily: "MadeTommySoft",
      fontWeight: "500",
      letterSpacing: "0.06em",
      margin: "0",
    },
    pLarge: {
      fontSize: "20px",
      lineHeight: "150%",
      fontFamily: "MadeTommy",
      fontWeight: "400",
      letterSpacing: "0.06em",
      margin: "0",
    },
    pRegular: {
      fontSize: "16px",
      lineHeight: "150%",
      fontFamily: "MadeTommy",
      fontWeight: "400",
      letterSpacing: "0.06em",
      margin: "0",
    },
    pSmall: {
      fontSize: "14px",
      lineHeight: "150%",
      fontFamily: "MadeTommy",
      fontWeight: "400",
      letterSpacing: "0.06em",
      margin: "0",
    },
    tags: {
      fontSize: "16px",
      lineHeight: "120%",
      fontFamily: "MadeTommy",
      fontWeight: "400",
      letterSpacing: "0.06em",
      margin: "0",
    },
    cta: {
      textAlign: "center",
      fontFamily: "MadeTommySoft",
      fontSize: "16px",
      fontStyle: "normal",
      fontWeight: 500,
      lineHeight: "130%",
      letterSpacing: "0.0675em",
    },
    captions: {
      fontSize: "14px",
      lineHeight: "120%",
      fontFamily: "MadeTommySoft",
      fontWeight: "500",
      letterSpacing: "0.06em",
      margin: "0",
    },
    unset: {
      fontSize: "inherit",
      lineHeight: "inherit",
      fontFamily: "inherit",
      fontWeight: "inherit",
      letterSpacing: "inherit",
      margin: "0",
    },
    ctaSmall: {
      textAlign: "center",
      fontFamily: "MadeTommySoft",
      fontSize: "16px",
      fontWeight: "500",
      lineHeight: "130%",
      letterSpacing: "0.06em",
      margin: "0",
    },
  },
  tablet: {
    h2: {
      fontSize: "26px",
      lineHeight: "120%",
      fontFamily: "MadeTommySoft",
      fontWeight: "700",
      letterSpacing: "0.02em",
      margin: "0",
    },
  },

  mobile: {
    h1: {
      fontSize: "32px",
      lineHeight: "120%",
      fontFamily: "MadeTommySoft",
      fontWeight: "800",
      letterSpacing: "0.04em",
      margin: "0",
    },
    h2: {
      fontSize: "24px",
      lineHeight: "120%",
      fontFamily: "MadeTommySoft",
      fontWeight: "700",
      letterSpacing: "0.02em",
      margin: "0",
    },
    h3: {
      fontSize: "20px",
      lineHeight: "120%",
      fontFamily: "MadeTommySoft",
      fontWeight: "500",
      letterSpacing: "0.04em",
      margin: "0",
    },
    h4: {
      fontSize: "18px",
      lineHeight: "120%",
      fontFamily: "MadeTommySoft",
      fontWeight: "500",
      letterSpacing: "0.04em",
      margin: "0",
    },
    h5: {
      fontSize: "16px",
      lineHeight: "150%",
      fontFamily: "MadeTommySoft",
      fontWeight: "500",
      letterSpacing: "0.06em",
      margin: "0",
    },
    h6: {
      fontSize: "14px",
      lineHeight: "150%",
      fontFamily: "MadeTommySoft",
      fontWeight: "500",
      letterSpacing: "0.06em",
      margin: "0",
    },
    pLarge: {
      fontSize: "16px",
      lineHeight: "150%",
      fontFamily: "MadeTommy",
      fontWeight: "400",
      letterSpacing: "0.06em",
      margin: "0",
    },
    pRegular: {
      fontSize: "16px",
      lineHeight: "150%",
      fontFamily: "MadeTommy",
      fontWeight: "400",
      letterSpacing: "0.06em",
      margin: "0",
    },
    pSmall: {
      fontSize: "14px",
      lineHeight: "150%",
      fontFamily: "MadeTommy",
      fontWeight: "400",
      letterSpacing: "0.06em",
      margin: "0",
    },
    tags: {
      fontSize: "16px",
      lineHeight: "120%",
      fontFamily: "MadeTommy",
      fontWeight: "400",
      letterSpacing: "0.06em",
      margin: "0",
      textTransform: "uppercase",
    },
    cta: {
      textAlign: "center",
      fontFamily: "MadeTommySoft",
      fontSize: "16px",
      fontStyle: "normal",
      fontWeight: 500,
      lineHeight: "130%",
      letterSpacing: "0.0675em",
    },
    captions: {
      fontSize: "12px",
      lineHeight: "120%",
      fontFamily: "MadeTommySoft",
      fontWeight: "500",
      letterSpacing: "0.06em",
      margin: "0",
    },
    disclaimer: {
      fontSize: "12px",
      lineHeight: "130%",
      fontFamily: "MadeTommy",
      fontWeight: "400",
      letterSpacing: "0.04em",
      margin: "0",
    },
    unset: {
      fontSize: "inherit",
      lineHeight: "inherit",
      fontFamily: "inherit",
      fontWeight: "inherit",
      letterSpacing: "inherit",
      margin: "0",
    },
    ctaSmall: {
      textAlign: "center",
      fontFamily: "MadeTommySoft",
      fontSize: "16px",
      fontWeight: "500",
      lineHeight: "130%",
      letterSpacing: "0.06em",
      margin: "0",
    },
  },
}

export default typography
